import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Auth from './mixins/Auth';
import RequestHelper from './mixins/RequestHelper';
//import PerfectScrollbar from 'vue2-perfect-scrollbar';
//import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
  position: 'top-right',
  duration: 5000
});
//Vue.use(PerfectScrollbar);

Vue.config.productionTip = false;

Vue.mixin(Auth);
Vue.mixin(RequestHelper);

import TreeView from 'vue-json-tree-view';
Vue.use(TreeView);

Vue.prototype.$singleActionColumnWidth = 106;

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);

import './validation';

import VueScreen from 'vue-screen';
Vue.use(VueScreen, {
  mobile: 0,
  tablet: 769,
  desktop: 1024,
  widescreen: 1280,
  fullhd: 1600
});

import VueCollapse from 'vue2-collapse';

// Loading the plugin into the Vue.
Vue.use(VueCollapse);

// disabled console log in production
if (process.env.NODE_ENV === 'production') {
  console.log = function() {};
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
